import React from 'react';

import {
  SvgWrapper,
  SvgWrapperProps,
} from 'components/svgs/SvgWrapper/SvgWrapper';

interface ProductVisitorOutlinedSvgProps
  extends Omit<SvgWrapperProps, 'children'> {}

export const ProductVisitorOutlinedSvg = ({
  ...svgProps
}: ProductVisitorOutlinedSvgProps) => (
  <SvgWrapper
    width="18"
    height="18"
    fill="var(--colorTextBase)"
    viewBox="0 0 18 18"
    {...svgProps}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.25 12C11.9411 12 12.5 12.5589 12.5 13.25C12.5 13.9411 11.9411 14.5 11.25 14.5H6.75C6.05886 14.5 5.5 13.9411 5.5 13.25C5.5 12.5589 6.05886 12 6.75 12H11.25ZM6.75 13C6.61114 13 6.5 13.1111 6.5 13.25C6.5 13.3889 6.61114 13.5 6.75 13.5H11.25C11.3889 13.5 11.5 13.3889 11.5 13.25C11.5 13.1111 11.3889 13 11.25 13H6.75Z"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9 6C10.3807 6 11.5 7.11931 11.5 8.5C11.5 9.88069 10.3807 11 9 11C7.61931 11 6.5 9.88069 6.5 8.5C6.5 7.11931 7.61931 6 9 6ZM9 7C8.17159 7 7.5 7.67159 7.5 8.5C7.5 9.32841 8.17159 10 9 10C9.82841 10 10.5 9.32841 10.5 8.5C10.5 7.67159 9.82841 7 9 7Z"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.25 3C13.4911 3 14.5 4.00886 14.5 5.25V15.25C14.5 16.4911 13.4911 17.5 12.25 17.5H5.75C4.50886 17.5 3.5 16.4911 3.5 15.25V5.25C3.5 4.00886 4.50886 3 5.75 3H12.25ZM5.75 4C5.06114 4 4.5 4.56114 4.5 5.25V15.25C4.5 15.9389 5.06114 16.5 5.75 16.5H12.25C12.9389 16.5 13.5 15.9389 13.5 15.25V5.25C13.5 4.56114 12.9389 4 12.25 4H5.75Z"
    />
    <path d="M10.0605 2.14648C9.47478 2.73217 8.52522 2.73217 7.93945 2.14648L5.79297 0H7.20703L8.64648 1.43945C8.84173 1.63461 9.15827 1.63461 9.35352 1.43945L10.793 0H12.207L10.0605 2.14648Z" />
  </SvgWrapper>
);
